/* ==========================================================================
   Product Recommendations LNT — fetch AJAX via Shopify
   ========================================================================== */

(function () {
  'use strict';

  document.querySelectorAll('.product-recos-lnt').forEach(function (section) {
    // Si Shopify a déjà rendu les recos (performed? == true), rien à faire
    if (section.dataset.hasRecommendations === 'true') return;

    const url = section.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Fetch failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('.product-recos-lnt');

        if (newSection) {
          // Si la nouvelle section a des recos, on remplace le contenu
          if (newSection.dataset.hasRecommendations === 'true') {
            section.innerHTML = newSection.innerHTML;
            section.dataset.hasRecommendations = 'true';
          } else {
            // Pas de recos disponibles : on cache la section
            section.hidden = true;
          }
        }
      })
      .catch(function (err) {
        console.warn('[product-recos-lnt] Erreur fetch recommandations', err);
        // En cas d'erreur, on cache la section plutôt que de laisser le skeleton
        section.hidden = true;
      });
  });
})();
